import React from 'react';
import { Typography } from '@mui/material';
import { Column } from 'components/shared/TableListing/types';
import { green, lightGreen } from '@mui/material/colors';
import { Money, Discount, PriceCheck, ArrowUpward, AttachMoney, CheckCircleOutlined } from '@mui/icons-material';

import { QuoteChargeListingEntity, QuoteChargeListingContext } from '../../../types';
import {
  DescriptionCell,
  ChargeValueCell,
  ReadOnlyValueCell,
  ChargeValueWithTypeCell,
  EquipmentChargeRowTotalCell,
  EquipmentChargeGrandTotalCell,
  EquipmentChargeColumnTotalCell,
} from './cells';

export const invoiceDetailsListingColumns: Column<QuoteChargeListingEntity, QuoteChargeListingContext>[] = [
  {
    header: 'Description',
    renderKey: 'type',
    renderCell: ({ rowIndex, context }) => (
      <DescriptionCell
        rowIndex={rowIndex}
        invoiceId={context.invoiceId}
        priceCalc={context.priceCalc}
        chargeService={context.chargeService}
        onEditEquipment={context.onEditEquipment}
        onRemoveEquipment={context.onRemoveEquipment}
        onRemoveRow={() => context.onRemoveRow(rowIndex)}
      />
    ),
    renderFooter: () => <Typography>Total</Typography>,
    headerStyles: {
      minHeight: 'auto',
    },
    width: '18rem',
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    renderKey: 'wholesalePrice',
    header: 'Wholesale Price',
    startIcon: <PriceCheck fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueCell rowIndex={rowIndex} type="wholesalePrice" />,
    renderFooter: ({ context: { priceCalc } }) => (
      <EquipmentChargeColumnTotalCell field="wholesalePrice" priceCalc={priceCalc} />
    ),
    headerStyles: {
      minHeight: 'auto',
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Markup',
    renderKey: 'markup',
    startIcon: <ArrowUpward fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueWithTypeCell rowIndex={rowIndex} type="markup" />,
    renderFooter: ({ context: { priceCalc } }) => (
      <EquipmentChargeColumnTotalCell priceCalc={priceCalc} field="markup" />
    ),
    headerStyles: {
      minHeight: 'auto',
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Retail Price',
    renderKey: 'retailPrice',
    startIcon: <AttachMoney fontSize="small" />,
    renderCell: ({ rowIndex, context: { priceCalc } }) => (
      <ReadOnlyValueCell rowIndex={rowIndex} type="retailPrice" priceCalc={priceCalc} />
    ),
    renderFooter: ({ context: { priceCalc } }) => (
      <EquipmentChargeColumnTotalCell priceCalc={priceCalc} field="retailPrice" />
    ),
    headerStyles: {
      minHeight: 'auto',
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Discount',
    renderKey: 'discount',
    startIcon: <Discount fontSize="small" />,
    renderCell: ({ rowIndex }) => <ChargeValueWithTypeCell rowIndex={rowIndex} type="discount" />,
    renderFooter: ({ context: { priceCalc } }) => (
      <EquipmentChargeColumnTotalCell field="discount" priceCalc={priceCalc} />
    ),
    headerStyles: {
      minHeight: 'auto',
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Net Price',
    renderKey: 'netPrice',
    startIcon: <Money fontSize="small" />,
    renderCell: ({ rowIndex, context: { priceCalc } }) => (
      <ReadOnlyValueCell rowIndex={rowIndex} type="netPrice" priceCalc={priceCalc} />
    ),
    renderFooter: ({ context: { priceCalc } }) => (
      <EquipmentChargeColumnTotalCell field="netPrice" priceCalc={priceCalc} />
    ),
    headerStyles: {
      minHeight: 'auto',
    },
    cellStyles: {
      minWidth: '10rem',
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
  {
    header: 'Total',
    renderKey: 'total',
    startIcon: <CheckCircleOutlined fontSize="small" />,
    renderCell: ({ rowIndex, context: { priceCalc } }) => (
      <EquipmentChargeRowTotalCell rowIndex={rowIndex} priceCalc={priceCalc} />
    ),
    renderFooter: ({ context: { priceCalc } }) => <EquipmentChargeGrandTotalCell priceCalc={priceCalc} />,
    width: '12rem',
    headerStyles: {
      minHeight: 'auto',
    },
    cellStyles: {
      alignItems: 'flex-start',
    },
    footerStyles: {
      minHeight: 'auto',
      color: green[800],
      backgroundColor: lightGreen['50'],
    },
  },
];
